import dayjs from 'dayjs'

/** The reminder API stores local wall-clock times, like the lead-task API. */
export const normalizeReminderPayloadDates = <T extends { due_at?: unknown; expires_at?: unknown }>(payload: T): T => {
    const result = { ...payload }
    for (const field of ['due_at', 'expires_at'] as const) {
        const value = payload[field]
        if (typeof value !== 'string' || !value.trim()) continue
        const date = dayjs(value)
        if (date.isValid()) {
            Object.assign(result, { [field]: date.format('YYYY-MM-DD HH:mm:ss') })
        }
    }
    return result
}
